'use client';

import cx from 'classnames';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import React, { FC } from 'react';

import PartBreadcrumbs from '../part-breadcrumbs/part-breadcrumbs';
import { IContentImage } from '@/contentful/utils/contentImage';

import IconLineLeftBig from './assets/icon-line-left-big.svg';
import IconLineLeftSmall from './assets/icon-line-left-small.svg';
import IconLineRightBig from './assets/icon-line-right-big.svg';
import IconLineRightSmall from './assets/icon-line-right-small.svg';

import styles from './part-page-banner.module.scss';

interface IPartPageBanner {
  data: {
    title: string;
    category?: string;
    imageDesktop: IContentImage | null;
    imageMobile: IContentImage | null;
  };
  category?: boolean;
  parentPage?: {
    text: string;
    href: string;
  }[];
}

const PartPageBanner: FC<IPartPageBanner> = ({
  data,
  category = false,
  parentPage,
}) => {
  const pathname = usePathname();

  return (
    <section className={styles.container}>
      <div className={styles.wrap}>
        {category ? (
          <div className={styles.content}>
            <IconLineLeftBig />
            <h1 className={styles.title}>{data.title}</h1>
            <IconLineRightBig />
          </div>
        ) : (
          <div className={cx(styles.content, styles.contentCategory)}>
            <div className={styles.categoryWrap}>
              <IconLineLeftSmall />
              <p className={styles.category}>{data.category}</p>
              <IconLineRightSmall />
            </div>
            <h1 className={styles.title}>{data.title}</h1>
          </div>
        )}

        <Image
          src={data.imageDesktop?.src ?? ''}
          alt={data.imageDesktop?.alt ?? ''}
          width={data.imageDesktop?.width ?? 0}
          height={data.imageDesktop?.height ?? 0}
          className={cx(
            styles.pageBannerContainer,
            'visibleOnDesktopAndTablet',
          )}
          quality={75}
          priority
        />
        <div
          className={cx(styles.pageBannerContainerMobileWrap, 'visibleOnPhone')}
        >
          <Image
            src={data.imageMobile?.src ?? ''}
            alt={data.imageMobile?.alt ?? ''}
            width={data.imageMobile?.width ?? 0}
            height={data.imageMobile?.height ?? 0}
            className={styles.pageBannerContainer}
            quality={75}
            priority
          />
        </div>
      </div>
      <div className={styles.breadCrumbsContainer}>
        <PartBreadcrumbs list={parentPage} text={data.title} href={pathname} />
      </div>
    </section>
  );
};

export default PartPageBanner;
